// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1jDAaa","container":"_3RnBMd","shine-lines":"kxrmY8"};